import axios from "axios";
export default {
    // render(h) {
    //     return h('el-form-item', {
    //         props: {
    //             label: this.obj.label + "：",
    //             prop: this.obj.name
    //         }
    //     }, form_item[this.ele](this, h))
    // },
    data() {
        return {
            filetype: [
                { name: ".doc", value: 1 },
                { name: ".docx", value: 1 },
                { name: ".ppt", value: 2 },
                { name: ".pptx", value: 2 },
                { name: ".pdf", value: 3 },
                { name: ".png", value: 4 },
                { name: ".jpg", value: 4 },
                { name: ".jpeg", value: 4 },
                { name: ".gif", value: 4 },
                { name: ".bmp", value: 4 },
                { name: ".mp4", value: 5 },
            ],
            loading: "",
        }
    },
    methods: {
        async upload(params) {
            const file = params.file,
                r = file.name.match(/([^\\/]+)\.([^\\/]+)/i),
                fileType = '.' + r[2],
                fileSize = file.size,
                fileName = r[1];
            if (fileSize > 1024 * 1024 * 50) {
                return new Promise((resolve, reject) => {
                    this.$message.error('文件大小超过50MB')
                    reject('文件大小超过50MB')
                })
            }
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const form = new FormData();
            form.append("file", file);
            console.log(window.sessionStorage.getItem("uploadUrl"));
            let res = await axios
                .post("/UploadFile", form, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        clientId: window.sessionStorage.getItem("clientId"),
                        token: window.sessionStorage.getItem("token"),
                    },
                })
            this.loading.close();
            return new Promise((resolve, reject) => {
                if (res.data.suc) {
                    resolve({ url: res.data.data.Path, name: fileName, size: fileSize, type: fileType, fileType: this.filetype.filter((el) => el.name == fileType).length > 0 ? this.filetype.filter((el) => el.name == fileType)[0].value : 0, })

                } else {
                    this.$message.error(res.data.msg)
                    reject(res.data.msg)
                }
            })

        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/upload.js